import { useState, useEffect } from 'react'
import styled from 'styled-components'
import SvgMap from 'components/SvgMap'

const GridItem = ({
  tenant,
  colorMode,
  titleText,
  data,
  isBig,
  showScale,
  min,
  max,
  minColor,
  midColor,
  maxColor,
}: /*
  index,
  colors,
  */
{
  tenant?: object
  colorMode?: string
  titleText: string
  data: any
  isBig?: boolean
  showScale?: boolean
  min?: number
  max?: number
  minColor: string
  midColor?: string
  maxColor: string
  /*
  index: number
  colors: object
  */
}) => {
  const [isMobile, setIsMobile] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 600)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  useEffect(() => {
    handleResize()
  }, [])

  return (
    <Griditem className={isMobile ? 'mobile' : 'desktop'}>
      <h4 lang='de'>
        <span
          className='title'
          dangerouslySetInnerHTML={{
            __html: titleText,
          }}
        />{' '}
      </h4>
      <div className='graphic'>
        <SvgMap
          data={data}
          min={min}
          max={max}
          minColor={minColor}
          midColor={midColor}
          maxColor={maxColor}
          colorMode={colorMode}
          isBig={isBig}
          showScale={showScale}
        />
      </div>
    </Griditem>
  )
}
const Griditem = styled.div`
  color: var(--text-color);
  width: 100%;
  max-width: 800px;
  margin: 0 auto 0;
  h4 {
    position: relative;
    font-size: 1.8rem;
    font-weight: 600;
    line-height: 2.4rem;
    @media only screen and (max-width: 600px) {
      font-size: 1.6rem;
      line-height: 1.9rem;
    }
    text-align: center;
    margin: 0 0 1.8rem;
    width: 100%;

    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
  }
  .graphic {
    position: relative;
  }
`

export default GridItem
